var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('lottie-animation',{ref:"anim",staticStyle:{"height":"100%"},attrs:{"autoPlay":"","loop":"","animationData":require('@/assets/loading-animation-credentials.json')},on:{"loopComplete":_vm.loopComplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }